import type { Nullable } from '@iheartjane/types';

export type SearchFilterFacet = {
  count?: number;
  end?: number;
  label: string;
  start?: number;
  value: string;
};

export type ProductSearchFilterFacet = {
  count: number;
  label: string;
  value: string;
};

type ProductSpecialSearchFilterFacet = {
  count: number;
  label: string;
  value: string;
};

export type PriceSearchFilterFacet = {
  count: number;
  end?: number;
  label: string;
  start?: number;
  value: string;
};

export type ProductSearchFilterCategory = ProductSearchFilterFacet & {
  subCategories: ProductSearchFilterFacet[];
};

export type ProductSearchFilter =
  ProductSearchFilterFacet[] | ProductSearchFilterCategory[];

export type RatingSearchFilterFacet = {
  count: number;
  label: string;
  start: number;
  value: string;
};

export type ProductSearchFiltersViewModel = {
  activities: ProductSearchFilterFacet[];
  brands: ProductSearchFilterFacet[];
  brandSpecials: ProductSearchFilterFacet[];
  categories: ProductSearchFilterCategory[];
  cbdPotencies: ProductSearchFilterFacet[];
  feelings: ProductSearchFilterFacet[];
  lineages: ProductSearchFilterFacet[];
  prices: PriceSearchFilterFacet[];
  ratings: RatingSearchFilterFacet[];
  specials: ProductSpecialSearchFilterFacet[];
  terpenes: ProductSearchFilterFacet[];
  thcPotencies: ProductSearchFilterFacet[];
  weights: ProductSearchFilterFacet[];
};

const ProductSearchFilterKeys = [
  'activities',
  'brands',
  'categories',
  'cbdPotencies',
  'feelings',
  'lineages',
  'prices',
  'ratings',
  'specials',
  'terpenes',
  'thcPotencies',
  'weights',
] as const;

export type ProductSearchFilterTypeKeys =
  (typeof ProductSearchFilterKeys)[number];

export function isProductSearchFilterTypeKey(
  key: string
): key is ProductSearchFilterTypeKeys {
  return (ProductSearchFilterKeys as readonly string[]).includes(key);
}

export type SliderFilterKeys = 'thcPotencies' | 'cbdPotencies';

export type FilterTypeKeys =
  | 'activities'
  | 'brands'
  | 'categories'
  | 'feelings'
  | 'lineages'
  | 'potencies'
  | 'prices'
  | 'ratings'
  | 'specials'
  | 'terpenes'
  | 'weights';

export type FilterTypeKeysWithJaneGold = FilterTypeKeys | 'jane-gold';

const DEFAULT_FILTER_TYPE_KEYS: FilterTypeKeys[] = [
  'categories',
  'terpenes',
  'brands',
  'lineages',
  'specials',
  'feelings',
  'activities',
  'ratings',
  'potencies',
  'prices',
  'weights',
];

const DEFAULT_FILTER_TYPE_KEYS_WITH_JANE_GOLD: FilterTypeKeysWithJaneGold[] = [
  'jane-gold',
  ...DEFAULT_FILTER_TYPE_KEYS,
];

function isFilterTypeKeyWithJaneGold(
  key: string
): key is FilterTypeKeysWithJaneGold {
  return DEFAULT_FILTER_TYPE_KEYS_WITH_JANE_GOLD.includes(
    key as FilterTypeKeysWithJaneGold
  );
}

export type FilterGroup = {
  filterKey: string; // FilterTypeKeys
  filterValues: string[];
};

export function buildFilterKeysToDisplay(display_filters?: Nullable<string[]>) {
  const filters = display_filters ?? [];
  return filters.length > 0
    ? filters.filter(isFilterTypeKeyWithJaneGold)
    : DEFAULT_FILTER_TYPE_KEYS_WITH_JANE_GOLD;
}
